// ============================================================================
// TAPUME — tela "vem novidade aí". Quando ATIVO, bloqueia TODAS as rotas
// (site, plataforma e manager) e mostra só a tela de novidades.
//
//   TAPUME_ATIVO = true   -> tapume LIGADO   (produção / fora de desenvolvimento)
//   TAPUME_ATIVO = false  -> tapume DESLIGADO (site liberado para desenvolvimento)
//
// Fluxo: ao COMEÇAR a desenvolver -> deixar `false` e fazer deploy.
//        ao TERMINAR o desenvolvimento -> voltar para `true` e fazer deploy.
//
// Bypass privado: abrir qualquer URL com `?dev=1` libera o site NESTE navegador
// mesmo com o tapume ligado (sem expor para o público). `?dev=0` remove o bypass.
// ============================================================================
export const TAPUME_ATIVO = true;

export function tapumeAtivo() {
  try {
    const p = new URLSearchParams(window.location.search);
    if (p.get('dev') === '1') localStorage.setItem('cc_dev', '1');
    if (p.get('dev') === '0') localStorage.removeItem('cc_dev');
    if (localStorage.getItem('cc_dev') === '1') return false; // bypass ativo
  } catch (_) { /* ambiente sem window/localStorage */ }
  return TAPUME_ATIVO;
}
